export default "__VITE_ASSET__DLwocin$__";